var exports = {
  "k": "x127c5a35--449b42--container",
};

module.exports = exports;
